import {ValueObject} from '@s-ui/domain'

export class PayOutParamsRequest extends ValueObject {
  /**
   * @param {String} adId
   * @param {String} sellerId
   * @param {String} buyerId
   * @param {String} iban
   **/

  static validate({adId, sellerId, buyerId, iban, validationError}) {
    const checkValidData = value => value !== null && value !== undefined && value !== ''
    if (!checkValidData(adId)) throw validationError(`Invalid ad id => ${adId}`)
    if (!checkValidData(sellerId)) throw validationError(`Invalid seller id => ${sellerId}`)
    if (!checkValidData(buyerId)) throw validationError(`Invalid buyer id => ${buyerId}`)
    if (!checkValidData(iban)) throw validationError(`Invalid IBAN => ${iban}`)
  }
}
